'use strict';

module.exports = function () {
    $('.sample-input').on('change', function(){
        $.spinner().start();
        if (!$(this).is(":checked")) {
            $.ajax({
                url: $(this).data('remove-url')+'&uuid=' + $(this).data('uuid'),
                type: 'get',
                data: form,
                dataType: 'json',
                success: function () {
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        } else {
            var sampleElmt = $(this);
            var form = {
                pid: $(this).data('pid'),
                quantity: 1,
                options: []
            };

            $.ajax({
                url: $(this).data('add-url'),
                type: 'post',
                data: form,
                dataType: 'json',
                success: function (data) {
                    sampleElmt.data('uuid', data.pliUUID);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};